import escapeHtml from 'escape-html';

export { escapeHtml };
